import React from 'react';
import { motion } from 'framer-motion';
import { ProductMockup } from './ProductMockup';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-surface-light text-primary min-h-[100svh] flex flex-col justify-center px-5 py-8 md:py-16" data-id="element-107" data-mp="23x4gwb3c69ts">
      <div className="max-w-3xl mx-auto text-center w-full" data-id="element-108" data-mp="2wjpe3s6htg59">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-display font-black tracking-tight text-[2rem] leading-[1.08] sm:text-5xl md:text-6xl mb-4 md:mb-6" data-id="element-109" data-mp="2wkikgs1ji3mv">
          Todo tu año de stretching resuelto{' '}
          <em className="italic font-bold text-accent" data-id="element-110" data-mp="3fgqfl30u8y4g">de una vez</em>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-sm sm:text-base md:text-lg text-primary/65 max-w-xl mx-auto mb-6 md:mb-10 leading-relaxed" data-id="element-111" data-mp="3kbe9jhem2kqf">
          Más de 500 instructores ya dejaron de improvisar. Llegas a cada clase
          con el sistema completo de planificación y fichas listas para dictar.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex justify-center mb-6 md:mb-10" data-id="element-112" data-mp="2u3mv0yom5l9c">
          <div className="w-60 sm:w-80 md:w-full md:max-w-lg" data-id="element-113" data-mp="1drzpx1gmk0gk">
            <ProductMockup data-id="element-114" data-mp="18sdaqmh8ka54" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-115" data-mp="38tur34u4wp0f">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={scrollToPricing} className="w-full sm:w-auto bg-accent text-white px-10 py-4 md:px-16 md:py-5 rounded-full font-bold text-base md:text-lg tracking-wide hover:bg-accent-dark transition-colors shadow-lg" data-id="element-116" data-mp="3itvdx0r7pn9d">
            QUIERO MI STRETCHING 360
          </motion.button>

          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 mt-5 md:mt-6 text-xs md:text-sm font-medium text-primary/70" data-id="element-117" data-mp="ab61f34lfx6i">
            <span data-id="element-118" data-mp="jc43hfvh1umg">Descarga inmediata</span>
            <span className="text-primary/30" data-id="element-119" data-mp="jcx3zz3u7nw5">·</span>
            <span data-id="element-120" data-mp="23u6choc8atgn">Sin suscripción</span>
            <span className="text-primary/30" data-id="element-121" data-mp="23v7lln9op5vq">·</span>
            <span data-id="element-122" data-mp="1yvl8rexrprng">Acceso de por vida</span>
          </div>
        </motion.div>
      </div>
    </section>;
}